import { render, staticRenderFns } from "./SectionVideo.vue?vue&type=template&id=6f379ae9&scoped=true&"
import script from "./SectionVideo.vue?vue&type=script&lang=js&"
export * from "./SectionVideo.vue?vue&type=script&lang=js&"
import style0 from "./SectionVideo.vue?vue&type=style&index=0&id=6f379ae9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f379ae9",
  null
  
)

export default component.exports